import styled from "styled-components";
import { auth, cartHelper, cartMultiReducer, customerOrdersHelper } from "@tiffin/app-common";
import { LoadingSpinner } from "@tiffin/components";
import { IOrderExt, OrderStatus } from "@tiffin/core";
import { useAppDispatch, useAppSelector } from "../hooks";

import { IonButton } from "@ionic/react";
import { Modal, Result } from "antd";
import { Unsubscribe } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

export const PostPayment = styled(BasePostPayment)`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;

  .header {
    background: #fff;
    padding: 20px;
    font-size: var(--font-size-medium);
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;

    ion-icon {
      font-size: var(--font-size-xlarge);
    }
  }

  .post-payment-loading {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
  }

  .received-confirmation {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-modal-body {
    height: 100%;
    color: var(--color-medium);
  }
`

interface IPostPayment {
  className?: string
}

function BasePostPayment(props: IPostPayment) {
  const partnerName = useAppSelector((state) => state.store.details?.name)
  const partnerId = useAppSelector((state) => state.store.details?.id)
  const partnerUrlName = useAppSelector((state) => state.store.details?.urlName)

  //Internal states
  const [ processing, setProcessing ] = useState(true)

  //Redux
  const dispatch = useAppDispatch()

  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  let { date } = useParams();

  const unsubOrder = useRef<Unsubscribe | null>(null)

  useEffect(() => {
    //Only run this hook if this is the active page
    const urlParams = new URLSearchParams(window.location.search)
    const orderId = urlParams.get("orderId")
    const tableNumber = urlParams.get("table")

    if(partnerId && date && orderId) {
      if(tableNumber) {
        //Remove dine in cart from session
        cartHelper.removeDineInCart(partnerId, date, orderId)
        setProcessing(false)
        dispatch(cartMultiReducer.fetchCart({refetch: true, tableNumber: parseInt(tableNumber)}))
        return;
      } else if(!auth.currentUser) {
        //Remove cart from session
        cartHelper.removeGuestCart(partnerId, date, orderId)
        setProcessing(false)
        dispatch(cartMultiReducer.fetchCart({refetch: true}))
        return;
      }
    }

    //Do not subscribe if already subscribed
    if(auth.currentUser && orderId && unsubOrder.current === null && partnerId) {
      unsubOrder.current = customerOrdersHelper.subscribeToOrder(orderId, (order: IOrderExt) => {
        if(order.status >= OrderStatus.Unconfirmed) {
          setProcessing(false)
          dispatch(cartMultiReducer.fetchCart({refetch: true}))
        }
      })
    }

    return () => {
      if(unsubOrder.current !== null) {
        unsubOrder.current()
        unsubOrder.current = null
      }
    }
  }, [partnerId, dispatch, navigate, date])

  const tableNumber = searchParams.get('table')

  const handleContinue = () => {
    if(auth.currentUser) {
      navigate({pathname: `/${partnerUrlName}/orders`, search: tableNumber !== null ? `table=${tableNumber}` : ''})
    } else {
      navigate({pathname: `/${partnerUrlName}`, search: tableNumber !== null ? `table=${tableNumber}` : ''})
    }
    setProcessing(false)
  }

  return(
    <Modal open={true} footer={[]} className={props.className}>
      {
        processing ?
        <div className="post-payment-loading">
          <LoadingSpinner />
        </div>
        :
        <div className="received-confirmation">
          <Result
            status="success"
            title="Your order has been received!"
            subTitle={<p style={{color: 'var(--ion-color-dark)'}}>Thank you for using Tifyn!<br/>Your order is awaiting confirmation from <b>{partnerName}</b></p>}
            extra={[
              <IonButton onClick={handleContinue}>Continue</IonButton>]}
          />
        </div>
      }
    </Modal>
  )
}
